import { render, staticRenderFns } from "./Obituary.vue?vue&type=template&id=11587ec5&"
import script from "./Obituary.vue?vue&type=script&lang=ts&"
export * from "./Obituary.vue?vue&type=script&lang=ts&"
import style0 from "./Obituary.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports